<ems-toast-message #ToastMessageComponent></ems-toast-message>

<sdps-notification id="sdpsConfirmationNotification" type="confirmation" class="sdps-m-top_none" *ngIf="(fileProcessStatus === 'Successful' && successMsg)">
  <p class="sdps-notification__text" id="sdpsConfirmationNotificationText" [innerHTML]="successMsg"></p>
  <p *ngIf="lib!=='ADDLINK'" id="sdpsConfirmationNotificationText">{{sharedConstant.bulkUpload.fileProcessing}}{{fileProcessStatus}}</p>
  <button class="cursor sdps-button sdps-messaging__close sch sch-x schwab-cross-icon sdps-p-top_x-small sdps-notification__text" type="button"
    aria-label="Close notification" (click)="closeInfo()"></button>
</sdps-notification>

<sdps-notification id="sdpsInfoNotification" type="information" class="sdps-m-top_none" *ngIf="fileUploadStatus">
  <div class="sdps-notification__text" id="sdpsInfoNotificationText">
    <div *ngIf="!showError && !showUploadError && showSuccessInfoMsg">
      <p [innerHTML]="successMsg"></p>
      <p [innerHTML]="sharedConstant.bulkUpload.uploadRedirectMsg"></p>
    </div>
  </div>
</sdps-notification>

<sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none" *ngIf="(showError || showUploadError)">
  <div class="sdps-notification__text" id="sdpsErrorNotificationText">
    <p *ngIf="showError && !showUploadError" [innerHTML]="errorMessage"></p>
    <p *ngIf="uploadErrorFileMsg" [innerHTML]="uploadErrorFileMsg"></p>
  </div>
</sdps-notification>

<sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none" *ngIf="uploadResponse.errorMessage">
  <div class="sdps-notification__text" id="sdpsErrorNotificationText">
    <p [innerHTML]="uploadResponse.errorMessage"></p>
  </div>
  <button class="sdps-button sdps-messaging__close sch sch-x schwab-cross-icon sdps-p-top_x-small" type="button"
    aria-label="Close notification" (click)="onClose('')"></button>
</sdps-notification>

<sdps-notification id="sdpsErrorNotification" type="error" class="sdps-m-top_none" *ngIf="(BulkUploadForm.get('planId').value && BulkUploadForm.get('planId').invalid && showPlanIDField)">
  <div class="sdps-notification__text" id="sdpsErrorNotificationText">
    <p [innerHTML]="sharedConstant.pleaseCorrectFollowingError"></p>
    <ul class="sdps-navigation--horizontal__list error-list">
      <li *ngIf="(BulkUploadForm.get('planId').value && BulkUploadForm.get('planId').invalid)"
        [innerHTML]="sharedConstant.textFieldErrorMsg.invalidNumericCharacterEntered"></li>
    </ul>
  </div>
</sdps-notification>

<h1 class="sr-only">Bulk Upload</h1>

<h2 *ngIf="this.getOrgId !== 0 || isMasterGroupUpload" class="page-title sdps-m-bottom_large sdps-p-left_small sdps-display-inline-block"
  [innerHTML]="bulkUploadTitles ? bulkUploadTitles : (this.sharedConstant.bulkUpload.bulkUploadText || 'Bulk Upload')"></h2>

<span *ngIf="this.getOrgId !== 0 || isMasterGroupUpload" class="sdps-m-horizontal_large client-selection-indicator"
      [ngClass]="this.externalAccess ? 'external-access' : sharedSer.showHistoricalView.value ? 'inactive-red' : (sharedSer.clientInformation | async)?.businessUnit | lowercase"
      [innerHTML]="(sharedSer.clientInformation | async)?.k4ClientName">

</span>

<sdps-notification id="sdpsInfoNotification" type="information"  class="sdps-m-top_none" *ngIf="this.getOrgId === 0 && !isMasterGroupUpload">
  <p class="sdps-notification__text" id="sdpsInfoNotificationText" [innerHTML]="sharedConstant.bulkUpload.noClientSelected"></p>
</sdps-notification>

<form [formGroup]="BulkUploadForm">
  <div class="file-upload" *ngIf="this.getOrgId !== 0 || isMasterGroupUpload">
    <!-- ADDLink - Master Account, Auth Agent, Plan Id & Remarks -->
    <div *ngIf="lib === 'ADDLINK'">
      <div class="file-section sdps-p-around_large">
      <div class="sdps-grid-fluid sdps-wrap">
        <div class="sdps-row col-full sdps-m-top_small no-padding-left">
          <!-- Master Account -->
          <div class="col-3 sdps-text-left" *ngIf="(((linkMethod === sharedConstant.bulkGlobal.multi && (countOfSL === 0 || countOfSL > 1)) || linkMethod === sharedConstant.bulkGlobal.standard) && (usertype === sharedConstant.bulkGlobal.external)) || usertype === sharedConstant.bulkGlobal.internal">
            <ems-multiselect [highlightColor]="true" [singleSelect]="false" [label]="'Master Account'" [searchable]="false"
              [options]="masterAccountOptions" formControlName="masterAccounts" [linkType]="linkMethod"
              [disabled]="linkMethod === sharedConstant.bulkGlobal.multi && countOfSL === 1 && usertype === sharedConstant.bulkGlobal.internal">
            </ems-multiselect>

          </div>

          <!-- Plan ID -->
          <div class="col-3" *ngIf="showPlanIDField">
            <div class="ems-input link-input-textbox"
              [ngClass]="{'invalidField': (BulkUploadForm.get('planId').value && BulkUploadForm.get('planId').invalid)}">
              <p-floatlabel variant="in">
                <input id="bulkPlanId" type="number" onkeypress="return (event.which >= 48 && event.which <= 57 && this.value.length < 10)" formControlName="planId" emsNumberPatterncheck [ariaLabel]="'Plan ID'" pInputText (blur)="removeLeadingZeroes()"/>
                <label for="bulkPlanId">Plan ID<em class="highlight-color">*</em></label>
              </p-floatlabel>
            </div>
          </div>

          <!-- Auth Agent -->
          <div class="col-3 sdps-text-left" *ngIf="!isAuthAgentRole">

            <ems-multiselect [highlightColor]="true" [singleSelect]="true" [label]="'Authorized Agent'" [searchable]="true"
              [options]="authorizedAgents" formControlName="authAgent">
            </ems-multiselect>
            <div class="ems-add-auth"
              *ngIf="isAAExceptBU && sharedSer.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid,'','')">
            </div>
          </div>

          <!-- Remarks -->
          <div class="col-3 remark-container">
            <div class="ems-input link-input-textbox">
              <p-floatlabel variant="in">
                <input id="bulkRemarks" type="text" formControlName="remarks" maxlength="1000" emsCharacterLimit
                  (emsCharacterLimitCheck)="showRemarksTxtboxCharLimit = $event"
                  [charMaxLimit]="commonConstants.charLimitValues.thousandMaxLimit" [ariaLabel]="'Remarks'" pInputText>
                <label for="bulkRemarks" class="float-label-top">Remarks<em
                    *ngIf="BulkUploadForm.get('doNotShowRemarkToClient').value === true" class="highlight-color">*</em></label>
              </p-floatlabel>
            </div>
            <p class="sdps-text-right sdps-m-around_none sdps-text-small line-height-nml"
                *ngIf="BulkUploadForm.get('remarks').value.length > showRemarksTxtboxCharLimit">
                {{commonConstants.characterLimit}}
                <span class="character-limit">{{BulkUploadForm.get('remarks').value.length}}
                  /{{commonConstants.charLimitValues.thousandMaxLimit}}</span>
              </p>
            <div class="ems-checkbox sdps-text-left"
              *ngIf="!isAuthAgentRole || sharedSer.checkEntitlements(entitlementConst.navUUID.addlnkAdminResource.uuid,'','') && usertype === sharedConstant.bulkGlobal.internal">
              <p-checkbox inputId="doNotShowRemarkToClient" formControlName="doNotShowRemarkToClient"
                [ariaLabel]="'Do not show this remark to Client'" binary="true"></p-checkbox>
                <label for="doNotShowRemarkToClient" class="sdps-p-left_xx-small">Do not show this remark to Client</label>
            </div>

          </div>
        </div>
      </div>
    </div>
    </div>

    <!-- Download Template -->
    <p class="sdps-m-bottom_large">&nbsp;</p>
    <div class="file-section sdps-p-around_large">
      <div class="display-content sdps-p-bottom_large"
        [innerHTML]="downloadTemplateLabel ? downloadTemplateLabel : this.sharedConstant.bulkUpload.defaultTemplateLabel">
      </div>
      <form (ngSubmit)="downloadFileSystem()">
        <label class="sr-only" for="bulkDownloadTemplate">Download template source</label>
        <input id="bulkDownloadTemplate" [(ngModel)]="downloadTemplate" name="file-system" type="hidden">
        <button class="buttons" [attr.aria-label]="sharedConstant.bulkUpload.downloadTemplateTxt || 'Download Template'" [innerText]="sharedConstant.bulkUpload.downloadTemplateTxt">
          <em class="pi pi-file sdps-p-right_x-small" aria-hidden="true"></em>
        </button>
      </form>
    </div>

     <!-- Choose File -->
     <p class="sdps-m-bottom_large">&nbsp;</p>
     <div class="spinner file-section sdps-p-around_large"  ems-drag-drop #content>
       <div class="display-content sdps-p-bottom_large" [innerHTML]="uploadText"></div> 
         <div class="widget" [attr.disabled]="lib === 'ADDLINK' ? !BulkUploadForm.valid : false" [ngClass]="(lib === 'ADDLINK' ? !BulkUploadForm.valid : false) ? 'disabled-widget' : 'cursor'">
          <label class="sr-only" for="bulkUploadWidget">Choose file to upload</label>
          <app-sch-file-upload-widget id="bulkUploadWidget" [attr.aria-label]="'Choose file to upload'" [channelContract]="channelDetails" [channelFileThresholdCount]=1 [overrideWidgetErrors]="overrideWidgetErrors"
          [widgetId]="'widget'" [tooltipConfig]="tooltipConfig" [reHydrate]="reHydrateData" [errorDisplay]="errorDisplay" [needFileStatus]="false"></app-sch-file-upload-widget>
         </div>
       </div>
     <p class="sdps-m-bottom_x-large">&nbsp;</p>
   </div>



    
 </form>